// Canonical metadata for the 5 Sanaa products.
export const PRODUCTS = [
  {
    key: "creative",
    name: "Sanaa Creative",
    tagline: { en: "Your AI design department.", ar: "قسم تصميم الذكاء الاصطناعي.", fr: "Votre département design IA.", sw: "Idara yako ya muundo wa AI." },
    disrupt: "Adobe Creative Cloud",
    accent: "#e1306c",
    accentVar: "--sanaa-creative",
    gradient: "linear-gradient(135deg, #E1306C, #F56040, #833AB4)",
    icon: "Sparkles",
    logo: "/logos/sanaa.png",
    blurb: {
      en: "From brief to 50 production-ready assets in seconds. Reads Adobe files. Speaks Arabic, Swahili, French, English.",
      ar: "من الفكرة إلى ٥٠ أصلًا جاهزًا في ثوانٍ. يقرأ ملفات Adobe.",
      fr: "Du brief à 50 assets en quelques secondes. Lit les fichiers Adobe.",
      sw: "Kutoka brief hadi vipande 50 vya tayari kwa sekunde. Inasoma faili za Adobe.",
    },
    route: "/app/creative",
  },
  {
    key: "falcon",
    name: "Falcon AI",
    tagline: { en: "Bloomberg-grade intelligence at 1/20th the cost.", ar: "ذكاء بمستوى Bloomberg بسُدس العشرين من السعر.", fr: "L'intelligence de Bloomberg, à 1/20e du prix.", sw: "Akili ya kiwango cha Bloomberg kwa gharama ya 1/20." },
    disrupt: "Bloomberg Terminal",
    accent: "#4c72cb",
    accentVar: "--sanaa-falcon",
    gradient: "linear-gradient(135deg, #0A369D, #4C72CB)",
    icon: "TrendingUp",
    logo: "/logos/falcon.png",
    blurb: {
      en: "Ask a question. Get a cited research brief, scenario analysis, and GCC/Africa implications.",
      ar: "اسأل سؤالاً واحصل على تقرير بحثي موثق.",
      fr: "Posez une question. Recevez une note de recherche citée.",
      sw: "Uliza swali. Pata ripoti ya utafiti iliyotajwa.",
    },
    route: "/app/falcon",
  },
  {
    key: "mizan",
    name: "Mizan AI",
    tagline: { en: "MATLAB is the past. Mizan is the future.", ar: "MATLAB من الماضي. Mizan هو المستقبل.", fr: "MATLAB est le passé. Mizan est le futur.", sw: "MATLAB ni zamani. Mizan ni siku zijazo." },
    disrupt: "MATLAB / Simulink",
    accent: "#00c2a8",
    accentVar: "--sanaa-mizan",
    gradient: "linear-gradient(135deg, #008B74, #00C2A8)",
    icon: "Cpu",
    logo: "/logos/mizan.png",
    blurb: {
      en: "Paste MATLAB. Get verified Python. Plus a natural-language engineering co-pilot.",
      ar: "الصق MATLAB. احصل على Python موثق.",
      fr: "Collez MATLAB. Obtenez du Python vérifié.",
      sw: "Bandika MATLAB. Pata Python iliyothibitishwa.",
    },
    route: "/app/mizan",
  },
  {
    key: "sahel",
    name: "Sahel AI",
    tagline: { en: "Design like you mean it. Build like you need it.", ar: "صمم بجدية. ابنِ بما تحتاج.", fr: "Concevez sérieusement. Construisez intelligemment.", sw: "Buni kwa makusudi. Jenga kwa ulazima." },
    disrupt: "AutoCAD / Revit",
    accent: "#00b4d8",
    accentVar: "--sanaa-sahel",
    gradient: "linear-gradient(135deg, #00B4D8, #48CAE4)",
    icon: "Building2",
    logo: "/logos/sahel.png",
    blurb: {
      en: "Text-to-CAD. Permit-ready floor plans from a single sentence, tuned to local building codes.",
      ar: "نص إلى CAD. مخططات جاهزة من جملة واحدة.",
      fr: "Texte vers CAO. Plans prêts à permis depuis une phrase.",
      sw: "Maandishi-kwa-CAD. Mipango tayari kutoka sentensi moja.",
    },
    route: "/app/sahel",
  },
  {
    key: "sufi",
    name: "Sufi AI",
    tagline: { en: "Complex simulation, simple words.", ar: "محاكاة معقدة، كلمات بسيطة.", fr: "Simulation complexe, mots simples.", sw: "Uchanganuzi mgumu, maneno rahisi." },
    disrupt: "CATIA / NX / ANSYS",
    accent: "#6930c3",
    accentVar: "--sanaa-sufi",
    gradient: "linear-gradient(135deg, #6930C3, #5E60CE)",
    icon: "Atom",
    logo: "/logos/sufi.png",
    blurb: {
      en: "Inverse design: state the requirement, get optimized geometry and auto-drafted PPAP docs.",
      ar: "تصميم عكسي: حدد المتطلبات.",
      fr: "Design inversé : énoncez l'exigence.",
      sw: "Muundo wa kurudi nyuma: eleza hitaji.",
    },
    route: "/app/sufi",
  },
];

export const productByKey = (k) => PRODUCTS.find((p) => p.key === k);
